import { render, staticRenderFns } from "./DefaultContacts.vue?vue&type=template&id=7f798c7e&"
import script from "./DefaultContacts.vue?vue&type=script&lang=js&"
export * from "./DefaultContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports